module.exports = __webpack_public_path__ + "static/media/santos.0b5e4d43.svg";